import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { convertAutomatically, removeCommas } from './utilities';

// 時給/日給・単価の入力欄 (#3114)。
//
// これらの欄は素の <input> で、親 (CompanyPayrollsTable#handleInputChange) の
// IME ガードは `isComposing` のイベントを **捨てるだけ** だった。生の値を表示せず
// compositionend での再処理も無いため、日本語入力 ON のまま打つと変換中の入力が
// すべて破棄され「入力できない」状態になっていた。
//
// FloatInput / TimeInput / NumberOrTimePlusInput と同じ方式に揃える。
// 変換中は生の値をそのまま表示し、確定時に一度だけ親へ流す。
class WageInput extends Component {
  constructor(props) {
    super(props);
    this.state = { composingValue: null };
    this.isComposing = false;
  }

  handleCompositionStart = () => {
    this.isComposing = true;
  };

  handleCompositionEnd = (event) => {
    this.isComposing = false;
    // 変換確定。ここで半角へ変換してから親へ渡す。
    //
    // 親 (CompanyPayrollsTable#handleInputChange) は event.nativeEvent.isComposing で
    // 弾く実装なので、compositionend 由来のイベントはそのまま通る。ただし
    // event.target.value は全角のままなので、FloatInput と同じく **変換後の値で
    // 上書きしてから** 渡さないと全角が保存される。
    const converted = convertAutomatically(removeCommas(event.target.value), '');

    this.setState({ composingValue: null });
    event.target.value = converted;
    this.props.onChange(event);
  };

  handleChange = (event) => {
    if (this.isComposing) {
      // 変換中は親へ渡さず、生の値をそのまま見せる。ここで親へ渡すと
      // 半角変換された値が controlled input へ書き戻り、IME がバッファを
      // 再挿入して文字が重複する (#922 / PR #1851 と同じ罠)。
      this.setState({ composingValue: event.target.value });
      return;
    }

    // 変換中でないときは自前の state を持たない。親の value をそのまま映す
    // controlled input に戻す。composingValue が既に null なら setState しない
    // (毎打鍵で余計な再描画を起こさない)。
    if (this.state.composingValue !== null) {
      this.setState({ composingValue: null });
    }
    this.props.onChange(event);
  };

  render() {
    const { value, onFocus, name, dataUid, className } = this.props;
    const { composingValue } = this.state;

    return (
      <input
        className={className}
        data-uid={dataUid}
        name={name}
        onChange={this.handleChange}
        onCompositionEnd={this.handleCompositionEnd}
        onCompositionStart={this.handleCompositionStart}
        onFocus={onFocus}
        type="text"
        value={composingValue !== null ? composingValue : value}
      />
    );
  }
}

WageInput.propTypes = {
  className: PropTypes.string,
  dataUid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

WageInput.defaultProps = {
  className: 'inputNumber w9',
  value: '',
};

export default WageInput;
